import { compact } from 'lodash';

export const alerts = {
  namespaced: true,
  state: () => {
    return {
      activeTopAlerts: [],
      updateExists: false,
      showPushNotificationBanner: false,
    };
  },
  getters: {
    getActiveTopAlerts: (state, getters, rootState, rootGetters) => {
      const todayServicesAlert = rootGetters['services/getTodayServices']?.length
        ? {
            identifier: 'todays_services_alert',
            isComponent: true,
            component: 'TodaysServicesAlert',
          }
        : undefined;

      const impersonationAlert =
        rootGetters['auth/GET_IMPERSONATION_SESSION'].active && rootGetters['auth/isGlobalUser']
          ? {
              identifier: 'impersonation_alert',
              isComponent: true,
              component: 'ImpersonationAlert',
            }
          : undefined;

      const appUpdateAlert = state.updateExists
        ? { identifier: 'app_update_alert', isComponent: true, component: 'AppUpdateAlert' }
        : undefined;

      const pushNotificationAlert = state.showPushNotificationBanner
        ? {
            identifier: 'push_notification_alert',
            isComponent: true,
            component: 'PushNotificationAlert',
          }
        : undefined;

      const offlineAlert = !rootGetters['getOnlinePresence']
        ? { identifier: 'offline_alert', isComponent: true, component: 'OfflineAlert' }
        : undefined;

      // Show on all routes until verification is completed.
      const verificationExpirationAlert =
        !rootGetters['auth/isGlobalUser'] && !rootGetters['auth/isAuthOrgVerified']
          ? {
              identifier: 'verification_expiration_alert',
              isComponent: true,
              component: 'VerificationExpirationAlert',
            }
          : undefined;

      // const verificationGracePeriodAlert =
      //   !rootGetters['auth/isGlobalUser'] &&
      //   rootGetters['auth/isAuthOrgNotVerifiedAndWithinGracePeriod'] &&
      //   rootGetters['getCurrentRoute'] !== 'church_verification_docs_settings'
      //     ? {
      //         identifier: 'verification_grace_period_alert',
      //         isComponent: true,
      //         component: 'VerificationGracePeriodAlert',
      //       }
      //     : undefined;

      const missingTimeZoneAlert =
        !rootGetters['auth/isGlobalUser'] &&
        !rootGetters['organisations/organisation_preferences/IS_CHURCH_TIMEZONE_SET']
          ? {
              identifier: 'missing_timezone_alert',
              isComponent: true,
              component: 'MissingTimeZoneAlert',
            }
          : undefined;

      const noChurchLanguageAlert =
        !rootGetters['auth/isGlobalUser'] &&
        !rootGetters['organisations/organisation_preferences/preferredChurchLanguage']
          ? {
              identifier: 'no_church_language_alert',
              isComponent: true,
              component: 'NoChurchLanguageAlert',
            }
          : undefined;

      const pendingOnboardingAlert =
        !rootGetters['auth/isGlobalUser'] &&
        rootGetters['onboardings/isOnboardingNotCompleted'] &&
        rootGetters['organisation_tasks/getExistenceDataLoaded'] &&
        rootGetters['auth/isOrgAdmin'] &&
        rootGetters['getCurrentRoute'] !== 'onboarding_data_migration'
          ? {
              identifier: 'pending_onboarding_alert',
              isComponent: true,
              component: 'PendingOnboardingAlert',
            }
          : undefined;

      const noPersonalProfileAlert = !rootGetters['auth/getAuthUser']?.personalProfile
        ? {
            identifier: 'no_personal_profile_alert',
            isComponent: false,
            text: 'Please update your personal profile',
            variant: 'warning',
          }
        : undefined;

      const noChurchHandleAlert =
        !rootGetters['auth/isGlobalUser'] && !rootGetters['auth/getAuthOrg']?.handle
          ? {
              identifier: 'create_church_handle_alert',
              isComponent: true,
              component: 'CreateChurchHandleAlert',
              variant: 'warning',
            }
          : undefined;

      const noChurchPublicPositionsAlert =
        !rootGetters['auth/isGlobalUser'] &&
        +(rootGetters['auth/getAuthOrg']?.meta?.public_positions || 0) === 0
          ? {
              identifier: 'no_church_public_positions_alert',
              isComponent: true,
              component: 'NoChurchPublicPositionsAlert',
              variant: 'warning',
            }
          : undefined;

      /**
       * Alerts are injected in order of priority
       */
      return compact([
        offlineAlert,
        appUpdateAlert,
        noPersonalProfileAlert,
        noChurchHandleAlert,
        noChurchPublicPositionsAlert,
        verificationExpirationAlert,
        // verificationGracePeriodAlert,
        pendingOnboardingAlert,
        missingTimeZoneAlert,
        noChurchLanguageAlert,
        todayServicesAlert,
        impersonationAlert,
        ...state.activeTopAlerts,
        pushNotificationAlert,
      ]);
    },
  },
  mutations: {
    setUpdateAvailability: (state, payload) => {
      state.updateExists = payload;
    },

    setTopAlert: (state, { identifier, isText, text, isComponent, component, variant }) => {
      state.activeTopAlerts.push({ identifier, isText, text, isComponent, component, variant });
    },

    removeTopAlert: (state, identifier) => {
      const alertIndex = state.activeTopAlerts.findIndex(
        (alert) => alert.identifier === identifier
      );
      if (alertIndex) {
        state.activeTopAlerts = state.activeTopAlerts.splice(alertIndex, 1);
      }
    },

    setPushNotificationBanner: (state, payload) => {
      state.showPushNotificationBanner = !!payload;
    },
  },
};
